import type { TimeSeriesSampling } from '@/shared/charts';

/**
 * Every numeric series, the speed graph included, keeps the first, lowest, highest and last point
 * of each pixel bucket, so a short peak can never disappear in the zoomed-out view.
 */
export const LINE_SAMPLING: TimeSeriesSampling = 'minmax';

/**
 * Samples further apart than this are not joined: the line breaks, as on the backend-drawn charts.
 * Without it a vehicle switched off overnight would show a straight line across the whole night.
 */
export const LINE_GAP_THRESHOLD_MS = 30 * 60 * 1_000;
